import Axios from "axios";
import {
  FinalConfirmationRequest,
  GetRegisteredSalesToApproveRequest,
  GetRegisteredSalesToApproveResponse,
  GetSaleInformationRequest,
  GetSaleInformationResponse,
  GetSettlementRequestDetailByKeyResponse,
  GetSettlementRequestHistoryRequest,
  GetSettlementRequestHistoryResponse,
  GetSettlementRequestsRequest,
  GetSettlementRequestsResponse,
  RegisterSettlementRequestRequest,
  SettlementListFilter,
  SettlemetRequestToApproveFilter,
  SettlmentRequestHistoryFilter,
} from "../models/settlement.model";
import { ApiResultModel } from "../models/common.model";
import { ApiBaseUrl, SettlementUrl } from "../config/config";

export const getRegisteredSalesToApprove = async (
  data: GetRegisteredSalesToApproveRequest
): Promise<ApiResultModel<GetRegisteredSalesToApproveResponse[]>> => {
  return await Axios.post<
    ApiResultModel<GetRegisteredSalesToApproveResponse[]>
  >(ApiBaseUrl + SettlementUrl + "/GetRegisteredSalesToApprove", data).then(
    (result) => {
      return result.data;
    }
  );
};
export const registerSettlementRequest = async (
  data: RegisterSettlementRequestRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SettlementUrl + "/RegisterSettlementRequest",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getSettlementRequests = async (
  data: GetSettlementRequestsRequest
): Promise<ApiResultModel<GetSettlementRequestsResponse[]>> => {
  return await Axios.post<ApiResultModel<GetSettlementRequestsResponse[]>>(
    ApiBaseUrl + SettlementUrl + "/GetSettlementRequests",
    data
  ).then((result) => {
    return result.data;
  });
};

export const finalConfirmation = async (
  data: FinalConfirmationRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SettlementUrl + "/FinalConfirmation",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const deleteSettlementRequest = async (data: {
  key: string;
}): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SettlementUrl + "/DeleteSettlementRequest",
    data
  ).then((result) => {
    return result.data.data;
  });
};
export const getSettlementRequestDetailByKey = async (data: {
  key: string;
}): Promise<GetSettlementRequestDetailByKeyResponse> => {
  return await Axios.post<
    ApiResultModel<GetSettlementRequestDetailByKeyResponse>
  >(ApiBaseUrl + SettlementUrl + "/GetSettlementRequestDetailByKey", data).then(
    (result) => {
      return result.data.data;
    }
  );
};
export const getSettlementRequestHistory = async (
  data: GetSettlementRequestHistoryRequest
): Promise<ApiResultModel<GetSettlementRequestHistoryResponse[]>> => {
  return await Axios.post<
    ApiResultModel<GetSettlementRequestHistoryResponse[]>
  >(ApiBaseUrl + SettlementUrl + "/GetSettlementRequestHistory", data).then(
    (result) => {
      return result.data;
    }
  );
};

export const getSaleInformation = async (
  data: GetSaleInformationRequest
): Promise<GetSaleInformationResponse> => {
  return await Axios.post<ApiResultModel<GetSaleInformationResponse>>(
    ApiBaseUrl + SettlementUrl + "/GetSaleInformation",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const getRegisteredSalesToApproveReportExcel = async (
  data: SettlemetRequestToApproveFilter
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SettlementUrl + "/GetRegisteredSalesToApproveReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست درخواست های تسویه"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
export const getSettlementRequestsReportExcel = async (
  data: SettlementListFilter
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SettlementUrl + "/GetSettlementRequestsReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست درخواست های تسویه"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
export const getSettlementRequestHistoryReportExcel = async (
  data: SettlmentRequestHistoryFilter
) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SettlementUrl + "/GetSettlementRequestHistoryReportExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"لیست تاریخچه درخواست های تسویه"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};

export const GetPaymentSettlementZipFile = async (data: { key: string }) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + SettlementUrl + "/GetPaymentSettlementZipFile",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"مستندات تسویه"}.zip`);
    document.body.appendChild(link);
    link.click();
  });
};

export const CancelWaitForSettlementSale = async (
  data: GetSaleInformationRequest
): Promise<boolean> => {
  return await Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SettlementUrl + "/CancelWaitForSettlementSale",
    data
  ).then((result) => {
    return result.data.data;
  });
};
